import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BadgeComponent',
  props: {
  variant: {
    type: String,
    default: 'plain',
    validator: (value: string) =>
      ['brand', 'success', 'warning', 'error', 'plain'].includes(value)
  },
  withBadge: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`badge --${props.variant}  ${props.withBadge && '--withBadge'}`)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})